module.exports = __webpack_public_path__ + "static/media/sidemenu_home.da041bc6.svg";